(ns kyber.events.eql
  (:require [kyber.events.utils :refer [add-auth base-uri kyber-event-fx]]))

(defn request
  [db params]
  (merge {:format :transit
          :headers (add-auth db)
          :method :post
          :response-format :transit
          :uri (base-uri db "/v1/eql")}
         params))

(defn no-auth-request
  [db params]
  (merge {:format :transit
          :method :post
          :response-format :transit
          :uri (base-uri db "/v1/no-auth-eql")}
         params))

(defn eql-tester-success
  [_ [_ request-payload response-payload]]
  {:tap> {:request request-payload
          :response response-payload}})

(kyber-event-fx ::eql-tester-success eql-tester-success)

(defn eql-tester-failure
  [_ [_ request-payload error]]
  {:tap> {:request request-payload
          :error error}})

(kyber-event-fx ::eql-tester-failure eql-tester-failure)

(defn eql-tester
  [{:keys [db]} [event-name eql-payload]]
  {:request
   (request db
            {:name event-name
             :params eql-payload
             :on-success [::eql-tester-success eql-payload]
             :on-failure [::eql-tester-failure eql-payload]})})

(kyber-event-fx ::eql-tester eql-tester)

(defn no-auth-eql-tester
  [{:keys [db]} [event-name eql-payload]]
  {:tap>
   {:request
    (no-auth-request db
                     {:name event-name
                      :params eql-payload
                      :on-success [::eql-tester-success eql-payload]
                      :on-failure [::eql-tester-failure eql-payload]})}})

(kyber-event-fx ::no-auth-eql-tester no-auth-eql-tester)
